
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, CivilStatus } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class CivilStatusEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    civilStatus: CivilStatus;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCivilStatus()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCivilStatus(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.civilStatus = data;
                this.onDataChanged.next(this.civilStatus);
                resolve(this.civilStatus);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('civilStatus/' + this.routeParams.id).subscribe((res: CivilStatus ) => {
                    this.civilStatus = res;
                    this.onDataChanged.next(this.civilStatus);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(civilStatus): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('civilStatus/', civilStatus).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(civilStatus): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('civilStatus/', civilStatus).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(civilStatus): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('civilStatus/' + civilStatus.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): CivilStatus {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
